import { render, staticRenderFns } from "./InvestecBankForm.vue?vue&type=template&id=73fb0772"
import script from "./InvestecBankForm.vue?vue&type=script&lang=js"
export * from "./InvestecBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports